import { Button } from '@/components';
import { cn } from '@/lib/cn';

type GoToPageButtonProps = {
    onClick: () => void;
    children: React.ReactNode;
    className?: string;
};
export const GoToPageButton = ({
    onClick,
    children,
    className,
}: GoToPageButtonProps) => {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClick();
    };
    return (
        <Button
            variant="ghost"
            className={cn('p-0 text-left font-bold underline', className)}
            onClick={handleClick}
        >
            {children}
        </Button>
    );
};
